import { c as _c } from "react/compiler-runtime";
import type { ReactNode, JSX } from 'react';
import { createContext, useContext } from 'react';
interface ContextValue {
  basePath: string;
}
export const CoverageApiContext = createContext<ContextValue>({
  basePath: ''
});
interface Props {
  basePath: string;
  children: ReactNode;
}

/**
 * Add this provider to _app to enable the use of all of the hooks.
 */
export function CoverageApiProvider(props) {
  const $ = _c(5);
  const {
    basePath,
    children
  } = props;
  let t0;
  if ($[0] !== basePath) {
    t0 = {
      basePath
    };
    $[0] = basePath;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== children || $[3] !== t0) {
    t1 = <CoverageApiContext.Provider value={t0}>{children}</CoverageApiContext.Provider>;
    $[2] = children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export function useCoverageApiBasePath() {
  const {
    basePath
  } = useContext(CoverageApiContext);
  return basePath;
}